import React from 'react';
import Select from 'react-select';
import get from 'lodash/get';

// The stored key and the CSS class names below still say "print": the setting
// started out as a print-only option and forms in the wild have already saved
// `printOptionsLayout`, while the PDF templates on the backend render the
// `print-options-*` classes. Renaming either would quietly reset every existing
// form to vertical, so only what people read has been renamed.
export const LAYOUT_OPTIONS_SETTING_KEY = 'printOptionsLayout';

// Matches how the options were laid out before the setting existed.
export const LAYOUT_OPTIONS_DEFAULT = 'vertical';

export const LAYOUT_OPTIONS = [
  { value: 'vertical', label: 'Vertical' },
  { value: 'horizontal', label: 'Horizontal' },
];

// The class that arranges the options, applied wherever the field is drawn.
export const getLayoutOptionsClass = (options) => `print-options-${options?.[LAYOUT_OPTIONS_SETTING_KEY] || LAYOUT_OPTIONS_DEFAULT}`;

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9,
  }),
};

// Controls how the field's options are arranged, everywhere the field appears:
// on the builder canvas, in the form being filled in, and in the printed PDF.
const LayoutOptionsSetting = ({ element, onChange }) => {
  const value = get(element, `options[${LAYOUT_OPTIONS_SETTING_KEY}]`) || LAYOUT_OPTIONS_DEFAULT;
  const activeOption = LAYOUT_OPTIONS.find((option) => option.value === value) || LAYOUT_OPTIONS[0];

  const handleChange = (option) => {
    if (!element?.id || !onChange) return;
    onChange(option.value, LAYOUT_OPTIONS_SETTING_KEY, element.id);
  };

  return (
    <div className="property-item">
      <h3 className="form-builder-aside-property-sub-title">Layout options</h3>
      <div className="form-control-item">
        <Select
          className="form-control-select"
          value={activeOption}
          options={LAYOUT_OPTIONS}
          styles={selectStyles}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default LayoutOptionsSetting;
